import { useState } from "react";

const ClientProtectionContentSeven = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleSection = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const sections = [
    {
      title: "How does The Pips protect my funds?",
      text: "We protect client funds through strict regulatory compliance, segregation of client accounts, and secure payment channels. Your money is always kept separate from operational funds and handled only through verified, monitored systems.",
    },
    {
      title: "Are my deposits and withdrawals secure?",
      text: "Yes. Every payment request goes through multi-layer authentication, encrypted processing, and fraud checks. Withdrawals to unverified accounts or mismatched names are automatically blocked for your safety.",
    },
    {
      title: "What should I do if I suspect fraud on my account?",
      text: "Contact our support team immediately. Provide any screenshots, emails, or suspicious activity logs. We will freeze the account, investigate the issue, and guide you through the next steps to recover access safely.",
    },
    {
      title: "How do you prevent unauthorized access to trading accounts?",
      text: "We use 2FA, identity verification, device monitoring, and login alerts. Suspicious or unusual account behaviour triggers automatic security checks and may temporarily restrict account activity.",
    },
    {
      title: "What types of trading scams should I watch out for?",
      text: "Phishing emails, fake “broker impersonation” messages, and malware are the most common. Always check sender details, avoid clicking unknown links, and never share passwords or verification codes with anyone.",
    },
    // {
    //   title: "Can I trade safely using public Wi-Fi?",
    //   text: "We strongly advise against trading on unsecured public networks. If necessary, use a trusted VPN to encrypt your data and prevent interception by malicious actors.",
    // },
    // {
    //   title: "What happens if my withdrawal takes longer than expected?",
    //   text: "Most withdrawals are processed within 24 hours, but delays can occur due to payment provider timelines or additional compliance checks. These checks ensure your funds remain safe and fully compliant with regulations.",
    // },
    // {
    //   title: "How can I reduce the risk of account compromise?",
    //   text: "Use strong, unique passwords, enable 2FA, update your devices regularly, avoid downloading unverified files, and never share your login credentials. Staying alert is your first line of defense.",
    // },
  ];

  return (
    <div className="how__work__trading">
      <div className="container">
        <div className="row">
          {/* LEFT SIDE IMAGE + TEXT */}
          <div className="col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="content-left">
              <h2>Frequently Asked Questions</h2>
            </div>
            <div className="thumb-left">
              <img
                src={process.env.PUBLIC_URL + "/images/trading/client_protection/client_protection_4.png"}
                alt="computer images"
              />
            </div>
          </div>

          {/* RIGHT SIDE ACCORDION */}
          <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
            <div className="content-right">
              <hr className="black-line" />
              {sections.map((section, index) => (
                <div key={index} className="accordion-section">
                  <button
                    className="accordion-header"
                    onClick={() => toggleSection(index)}
                  >
                    <h3>{section.title}</h3>
                    <span
                      className={`arrow ${openIndex === index ? "open" : ""}`}
                    >
                      ▼
                    </span>
                  </button>

                  <div
                    className={`accordion-content ${
                      openIndex === index ? "show" : ""
                    }`}
                  >
                    <p>{section.text}</p>
                  </div>

                  <hr className="black-line" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientProtectionContentSeven;
